var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.context.value)?_c('label',{staticClass:"mr-2",attrs:{"for":_vm.context.id}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":"2x","fixed-width":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }